import { ForumOutlineIcon } from './ForumOutlineIcon';

/**
 * author: Google
 * id E6469D88-74CE-4242-8226-85BB8F8EFFB0
 * name forum-outline
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/forum-outline.svg
 * tags
 */
export const DialogueOutlineIcon = ForumOutlineIcon;
export default DialogueOutlineIcon